import ConsumerRefService from "@api/consumer/consumerRefService";
import {IGoalBalanceReward, IGoalItemReward, IGoalReward} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {useNavigate} from "react-router";
import {GoalRewardFormValues} from "../forms/rewardBaseInfoBlock";
import GoalRewardForm from "./goalRewardForm";

interface EditGoalRewardFormProps {
    reward: IGoalReward;
}

const EditGoalRewardForm: FC<EditGoalRewardFormProps> = ({reward}) => {

    const navigate = useNavigate();

    const initialValues: GoalRewardFormValues = {
        name: reward.name,
        isActive: reward.isActive,
        type: reward.type,
        order: reward.order,

        balance: (reward as IGoalBalanceReward).balance || undefined,

        itemId: (reward as IGoalItemReward).itemId || undefined,
        count: (reward as IGoalItemReward).count || undefined
    }



    const onSubmit = useCallback(async (values: GoalRewardFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.patchGoalReward(reward.goalId, {
            id: reward.id,
            isActive: values.isActive,
            name: values.name,
            order: values.order,

            balance: values.balance,

            itemId: values.itemId,
            count: values.count
        });

        if (result.success) {
            toastr.success("Изменение награды", "Награда достижения успешно обновлена");
            navigate(`/consumer/goals/${result.data.goalId}/rewards/${result.data.id}/`, { replace: true });
        }
        else {
            if (result.errorCode === 'GoalNotFound') {
                toastr.error('Изменение награды', 'Достижение не найдено');
            }
            else if (result.errorCode === 'RewardNotFound') {
                toastr.error('Изменение награды', 'Награда не найдена');
            }
            else if (result.errorCode === 'InvalidRequest') {
                toastr.error('Изменение награды', 'Некорректные параметры награды');
            }
            else if (result.errorCode === 'DisabledItem') {
                toastr.error('Изменение награды', 'Предмет отключен');
            }
            else if (result.errorCode === 'InvalidType') {
                toastr.error('Изменение награды', 'Некорректный тип награды');
            }
            else {
                toastr.error('Изменение награды', 'Неизвестная ошибка');
            }
        }
    }, [navigate, reward.goalId, reward.id]);

    return (
        <GoalRewardForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={true}
            title={`Редактирование награды "${reward.name}"`}
            cancelUrl={`/consumer/goals/${reward.goalId}/rewards/`}
        />
    )
}

export default EditGoalRewardForm;
